import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { ContentService } from '@common/services/content.service';
import { RegistrationService } from '@enus/services/registration.service';
import { EnUsCommunityService } from '@enus/services/enus-community.service';
import { naturalSort } from '@enus/utils/natural-sort';
import { LanguageService } from '@common/services/language.service';

@Component({
    selector: 'app-home-sme',
    templateUrl: 'home-sme.component.html',
    styleUrls: ['home-sme.component.scss'],
    standalone: false
})
export class HomeSmeComponent implements OnInit, OnDestroy {
    private destroyed$ = new Subject<void>();

    participantCount$: Observable<number>;
    hero: string;
    logosCmsKeys$: Observable<string[]>;

    smeRegisterLink = '../register';

    public infoBullets = [
        { id: 1, routerLink: '../info/why-should-i-switch' },
        { id: 2, routerLink: '../register' },
        { id: 3, routerLink: '../info/who-is-ichoosr' }
    ];

    private logoCmsKeyBase = 'past-winning-supplier-logo';

    constructor(
        private service: RegistrationService,
        public contentService: ContentService,
        public communityService: EnUsCommunityService,
        private languageService: LanguageService
    ) {
        const communityCode = this.communityService.communityCode;
        const languageCode = this.languageService.currentLanguageCode;

        if (communityCode && languageCode) {
            this.smeRegisterLink = `/${languageCode}/sme/${communityCode}/register`;
        }

    }

    ngOnInit() {
        this.participantCount$ = this.service.count();

        this.contentService.value('hero-image')
            .pipe(
                takeUntil(this.destroyed$)
            )
            .subscribe(url => this.hero = url);

        this.logosCmsKeys$ = this.contentService.filter((key) => key.startsWith(this.logoCmsKeyBase))
            .pipe(
                map(contentArr => contentArr.map(content => content.key)),
                map(keys => naturalSort(keys))
            );
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
